import { render, staticRenderFns } from "./RenderPrimer.vue?vue&type=template&id=077c7fab&"
import script from "./RenderPrimer.vue?vue&type=script&lang=js&"
export * from "./RenderPrimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports